import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
// import { useDataStore } from './store/dataStore';

const app = createApp(App);
const pinia = createPinia();

app.use(router).use(pinia).mount('#app');

// 加载数据
// const dataStore = useDataStore();
// dataStore.fetchWordsData();  // 应用启动时调用
